webpackJsonp([168000803916113],{

/***/ 719:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Hero":"src-components-DayInTheLife-Hero----Hero-module---Hero---3JvQy"};

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeroModule = __webpack_require__(719);
	
	var _HeroModule2 = _interopRequireDefault(_HeroModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _HeroModule2.default.Hero, style: { backgroundImage: 'url("' + props.backgroundImage.file.url + '")' } },
	    _react2.default.createElement(
	      'h1',
	      null,
	      props.title
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      props.text
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Introduction":"src-components-DayInTheLife-Introduction----Introduction-module---Introduction---3FAYn","Introduction__Wrapper":"src-components-DayInTheLife-Introduction----Introduction-module---Introduction__Wrapper---1jWBt","Introduction__Media":"src-components-DayInTheLife-Introduction----Introduction-module---Introduction__Media---1SgGP","spacer":"src-components-DayInTheLife-Introduction----Introduction-module---spacer---1qm6P","Video":"src-components-DayInTheLife-Introduction----Introduction-module---Video---3FuA4"};

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VimeoEmbed = __webpack_require__(117);
	
	var _VimeoEmbed2 = _interopRequireDefault(_VimeoEmbed);
	
	var _IntroductionModule = __webpack_require__(720);
	
	var _IntroductionModule2 = _interopRequireDefault(_IntroductionModule);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Introduction = function Introduction(props) {
	  var videoBool = props.videoBool;
	
	  if (videoBool) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _IntroductionModule2.default.Introduction + ' ' + _IntroductionModule2.default.Video },
	        _react2.default.createElement(
	          'div',
	          { className: _IntroductionModule2.default.Introduction__Wrapper },
	          _react2.default.createElement(
	            'h2',
	            null,
	            props.title
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            props.text
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _IntroductionModule2.default.Introduction__Media },
	          _react2.default.createElement(_VimeoEmbed2.default, {
	            url: props.videoLink,
	            loop: false,
	            autoplay: false,
	            controls: true
	          })
	        )
	      ),
	      _react2.default.createElement('div', { className: _IntroductionModule2.default.spacer })
	    );
	  } else {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _IntroductionModule2.default.Introduction + ' ' + _IntroductionModule2.default.Image },
	        _react2.default.createElement(
	          'div',
	          { className: _IntroductionModule2.default.Introduction__Wrapper },
	          _react2.default.createElement(
	            'h2',
	            null,
	            props.title
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            props.text
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _IntroductionModule2.default.Introduction__Media },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: props.mediaAsset.sizes, alt: props.mediaAsset.title })
	        )
	      ),
	      _react2.default.createElement('div', { className: _IntroductionModule2.default.spacer })
	    );
	  }
	};
	
	exports.default = Introduction;
	module.exports = exports['default'];

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _FellowsModule = __webpack_require__(439);
	
	var _FellowsModule2 = _interopRequireDefault(_FellowsModule);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import styles from './MoreFellows.module.scss';
	
	
	var MoreFellows = function (_React$Component) {
	  _inherits(MoreFellows, _React$Component);
	
	  function MoreFellows(props) {
	    _classCallCheck(this, MoreFellows);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      selectedIndex: 0,
	      width: 0
	    };
	
	    _this.updateSelected = _this.updateSelected.bind(_this);
	    return _this;
	  }
	
	  MoreFellows.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var Flickity = __webpack_require__(309);
	    var carousel = document.querySelector('#fellowsSlider');
	    var options = {
	      cellSelector: '.fellowsCard',
	      contain: true,
	      initialIndex: 0,
	      adaptiveHeight: true,
	      accessibility: true,
	      wrapAround: true,
	      pageDots: false,
	      prevNextButtons: false,
	      lazyLoad: true,
	      percentPosition: false,
	      rightToLeft: true
	    };
	
	    window.setTimeout(function () {
	      _this2.flkty = new Flickity(carousel, options);
	      _this2.flkty.on('cellSelect', _this2.updateSelected);
	    }, 500);
	    this.setState({ width: window.innerWidth });
	    // window.addEventListener('resize', () => this.setState({ width: window.innerWidth }))
	  };
	
	  MoreFellows.prototype.updateSelected = function updateSelected() {
	    var index = this.flkty.selectedIndex;
	    this.setState({
	      selectedIndex: index
	    });
	  };
	
	  MoreFellows.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.flkty) {
	      this.flkty.off('cellSelect', this.updateSelected);
	      this.flkty.destroy();
	    }
	  };
	
	  MoreFellows.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: '' + _FellowsModule2.default.Fellows + (this.props.className ? ' ' + this.props.className : ''), style: this.props.style },
	      _react2.default.createElement(
	        'div',
	        { className: _FellowsModule2.default.Fellows__Wrapper },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Experience a day in the life of other fellows'
	        ),
	        (this.props.cards.length > 3 || this.state.width < 1080) && _react2.default.createElement(
	          'div',
	          { onClick: function onClick() {
	              return _this3.flkty.next();
	            }, className: _FellowsModule2.default.SelectArrow + ' ' + _FellowsModule2.default.SelectArrow__Prev },
	          _react2.default.createElement('img', { src: '/images/icon-circle-arrow.svg', alt: 'circle arrow' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _FellowsModule2.default.BlogCards, id: 'fellowsSlider' },
	          this.props.cards.map(function (card, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: _FellowsModule2.default.BlogCard + ' fellowsCard', key: i },
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: card.image.sizes, alt: card.image.title }),
	              _react2.default.createElement(
	                'div',
	                { className: _FellowsModule2.default.BlogCard__Text },
	                _react2.default.createElement(
	                  'p',
	                  { className: _FellowsModule2.default.BlogCard__Details },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Day in the life'
	                  ),
	                  ' / ',
	                  card.fellowsLocation
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { style: { marginBottom: '20px' } },
	                  card.fellowsQuote.fellowsQuote
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'hoverlink', to: card.fellowsLink.link },
	                  card.fellowsLink.text
	                )
	              )
	            );
	          })
	        ),
	        (this.props.cards.length > 3 || this.state.width < 1080) && _react2.default.createElement(
	          'div',
	          { onClick: function onClick() {
	              return _this3.flkty.previous();
	            }, className: _FellowsModule2.default.SelectArrow + ' ' + _FellowsModule2.default.SelectArrow__Next },
	          _react2.default.createElement('img', { src: '/images/icon-circle-arrow.svg', alt: 'circle arrow' })
	        )
	      )
	    );
	  };
	
	  return MoreFellows;
	}(_react2.default.Component);
	
	exports.default = MoreFellows;
	module.exports = exports['default'];

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Times":"src-components-DayInTheLife-Times----Times-module---Times---2bRc8","timeRight":"src-components-DayInTheLife-Times----Times-module---timeRight---1dxvz","timeLeft":"src-components-DayInTheLife-Times----Times-module---timeLeft---36T0S","Time":"src-components-DayInTheLife-Times----Times-module---Time---1RXgN"};

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimesModule = __webpack_require__(721);
	
	var _TimesModule2 = _interopRequireDefault(_TimesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Times = function Times(props) {
	  function isOdd(num) {
	    var number = num % 2;
	    return number === 1 ? true : false;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _TimesModule2.default.Times },
	    props.times.map(function (time, i) {
	      return _react2.default.createElement(
	        'div',
	        { key: i, className: _TimesModule2.default.Time },
	        _react2.default.createElement(
	          'div',
	          { className: (isOdd(i) ? _TimesModule2.default.timeRight : _TimesModule2.default.timeLeft) + ' time' },
	          time.time
	        ),
	        _react2.default.createElement('img', { src: time.image.file.url, alt: time.image.title, className: 'times-image' }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          time.title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          time.text.text
	        )
	      );
	    })
	  );
	};
	
	exports.default = Times;
	module.exports = exports['default'];

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _Hero = __webpack_require__(524);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Introduction = __webpack_require__(525);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	var _MoreFellows = __webpack_require__(526);
	
	var _MoreFellows2 = _interopRequireDefault(_MoreFellows);
	
	var _Fellows = __webpack_require__(25);
	
	var _Fellows2 = _interopRequireDefault(_Fellows);
	
	var _Times = __webpack_require__(527);
	
	var _Times2 = _interopRequireDefault(_Times);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DayInTheLife = function (_React$Component) {
	  _inherits(DayInTheLife, _React$Component);
	
	  function DayInTheLife() {
	    _classCallCheck(this, DayInTheLife);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DayInTheLife.prototype.componentDidMount = function componentDidMount() {
	    var ScrollReveal = __webpack_require__(149);
	    window.setTimeout(function () {
	      window.sr = ScrollReveal();
	      sr.reveal('.time', { duration: 600, scale: 1 });
	      sr.reveal('.times-image', { duration: 1600, opacity: 0.4, scale: 0.9, delay: -200 });
	    }, 200);
	  };
	
	  DayInTheLife.prototype.render = function render() {
	    var page = this.props.data.page;
	
	    var seoKeywords = page.seoData && page.seoData.keywords ? page.seoData.keywords.toString() : '';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'day' },
	      _react2.default.createElement(_CustomHelmet2.default, { data: page.seoData }),
	      _react2.default.createElement(_Hero2.default, {
	        title: page.title,
	        backgroundImage: page.heroImage,
	        text: page.heroText
	      }),
	      _react2.default.createElement(_Introduction2.default, {
	        title: page.introductionTitle,
	        text: page.introductionText.introductionText,
	        videoBool: page.videoBool,
	        videoLink: page.videoLink,
	        mediaAsset: page.introductionMedia
	      }),
	      _react2.default.createElement(_Times2.default, {
	        times: page.scheduleCards
	      }),
	      _react2.default.createElement(_MoreFellows2.default, {
	        cards: page.fellowsCards
	      }),
	      _react2.default.createElement(_Apply2.default, {
	        title: 'Curious about Global Citizen Year? This is a great place to start.'
	      })
	    );
	  };
	
	  return DayInTheLife;
	}(_react2.default.Component);
	
	exports.default = DayInTheLife;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-day-in-the-life-js-0ff9ca530d43ac7a03a5.js